module.exports = __webpack_public_path__ + "static/media/chart.6ba0a28d.svg";